import { observable, action } from 'mobx';

class TagsStore {
    @observable tags = [];

    @action
    add(tag) {
        this.tags.push(tag);
    }

    @action
    delete(tag) {
        this.tags.remove(tag)
    }
}

export default TagsStore;


// WEBPACK FOOTER //
// ./src/stores/tagsStore.js